import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-444537a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"8px"} }, "Planning Senario:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"8px"} }, "Planning Year:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"8px"} }, "Final Kufri:", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_a_select, {
      value: _ctx.planningName,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.planningName) = $event)),
      onChange: _ctx.handleChangePlanningName
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planningList, (version) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: version,
            value: version
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(version), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "onChange"]),
    _hoisted_2,
    _createVNode(_component_a_select, {
      value: _ctx.nextYear,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nextYear) = $event)),
      disabled: !_ctx.planningName,
      onChange: _ctx.handleChangeNextYear,
      class: "year"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearList, (version) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: version,
            value: version
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(version), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "disabled", "onChange"]),
    _hoisted_3,
    _createVNode(_component_a_select, {
      value: _ctx.planningId,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.planningId) = $event)),
      disabled: !_ctx.planningName || !_ctx.nextYear,
      class: "kufri"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kufriList, (kufri) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: kufri.id,
            value: kufri.id
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(kufri.name), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "disabled"]),
    _createVNode(_component_a_button, {
      type: "primary",
      class: "save-btn",
      onClick: _ctx.handleConfirm
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}